import { useCookie } from "./use-cookie";

const useSelectedEventIdCookie = () => useCookie("selectedEventId");

export { useSelectedEventIdCookie };
